export enum ObjectCriteriaGroup {
  Series = 'SERIES',
  SparePart = 'SPARE_PART',
  WildCard = 'WILD_CARD',
}

export enum WarrantyCalculationMethod {
  Zp8 = 'ZP8',
  CustomerDelivery = 'CUSTOMER_DELIVERY',
}

export enum YesNo {
  Yes = 'true',
  No = 'false',
}
